<template>
  <FiltersWatcher
    :filters="filters"
    @change="$emit('change', $event)"
  >
    <SectionGroup gap="larger">
      <FormSection title="Специализация">
        <SpecsPicker
          :groups="groups"
          :selected-categories="filters.s"
          :s-options="options.s"
          :allow-select-group="true"
          v-model="filters.s"
          :max-selected-categories-count="null"
        />
      </FormSection>
  
      <FormSection title="Квалификация">
        <InputGroup direction="vertical" gap="medium">
          <BasicCheckbox
            v-for="option in options.qualifications"
            v-model="filters.qualifications"
            :value="option.value"
            :key="option.title"
          >
            {{ option.title }}
          </BasicCheckbox>
        </InputGroup>
      </FormSection>
      
      <FormSection title="Опыт работы">
        <InputGroup direction="vertical" gap="medium">
          <BasicCheckbox
            v-for="option in options.experiences"
            v-model="filters.experiences"
            :value="option.value"
            :key="option.title"
          >
            {{ option.title }}
          </BasicCheckbox>
        </InputGroup>
      </FormSection>
  
      <FormSection title="Возраст">
        <InputRange
          :from.sync="filters.ageFrom"
          :to.sync="filters.ageTo"
          :max-length="3"
        />
      </FormSection>
      
      <FormSection title="Профессиональные навыки">
        <SkillsPicker
          v-model="filters.skills"
          :skills.sync="dynamicOptions.skills"
        />
      </FormSection>
  
      <FormSection title="Вознаграждение">
        <InputRangeGroup
          dropdown
          :from.sync="filters.salaryFrom"
          :to.sync="filters.salaryTo"
          :measure.sync="filters.currency"
          :measure-options="options.currency"
        />
      </FormSection>
      
      <FormSection title="Готовность к работе">
        <SectionGroup gap="medium-large">
          <BasicCheckbox
            v-for="option in options.availability"
            :key="option.value"
            v-model="filters.workStates"
            :value="option.value"
          >
            {{ option.title }}
          </BasicCheckbox>
          <div class="resume-filter__separator"></div>
          <BasicCheckbox
            v-model="filters.workStates"
            value="relocation"
          >
            Готов к переезду
          </BasicCheckbox>
          <BasicCheckbox
            v-model="filters.workStates"
            value="remote"
          >
            Готов к удалённой работе
          </BasicCheckbox>
        </SectionGroup>
      </FormSection>
      
      <FormSection title="Местоположение">
        <SectionGroup gap="medium">
          <LocationPicker
            v-model="filters.locations"
            multiple
            :locations.sync="dynamicOptions.locations"
          />
          <BasicCheckbox
            v-model="filters.excludeLocation"
            :value="1"
            :disabled="!filters.locations || filters.locations.length === 0"
          >
            Исключить из поиска
          </BasicCheckbox>
        </SectionGroup>
      </FormSection>
  
      <FormSection title="Компания">
        <SectionGroup gap="medium">
          <CompanyPicker
            v-model="filters.companies"
            multiple
            :companies.sync="dynamicOptions.companies"
          />
          <BasicCheckbox
            v-model="filters.excludeCompany"
            :value="1"
            :disabled="!filters.companies || filters.companies.length === 0"
          >
            Исключить из поиска
          </BasicCheckbox>
          <BasicCheckbox
            v-model="filters.isCurrentCompany"
            :value="1"
            :disabled="!filters.companies || filters.companies.length === 0"
          >
            Текущее место работы
          </BasicCheckbox>
        </SectionGroup>
      </FormSection>
  
      <FormSection title="Высшее образование">
        <SectionGroup gap="medium">
          <UniversityPicker
            v-model="filters.universities"
            multiple
            :universities.sync="dynamicOptions.universities"
          />
          <BasicCheckbox
            v-model="filters.excludeUniversity"
            :value="1"
            :disabled="!filters.universities || filters.universities.length === 0"
          >
            Исключить из поиска
          </BasicCheckbox>
        </SectionGroup>
      </FormSection>
  
      <FormSection title="Допобразование">
        <SectionGroup gap="medium">
          <EducationCenterPicker
            v-model="filters.extraEducations"
            multiple
            :extra-educations.sync="dynamicOptions.extraEducations"
          />
          <BasicCheckbox
            v-model="filters.excludeExtraEducation"
            :value="1"
            :disabled="!filters.extraEducations || filters.extraEducations.length === 0"
          >
            Исключить из поиска
          </BasicCheckbox>
        </SectionGroup>
      </FormSection>
  
      <FormSection title="Активность на сайте">
        <BasicSelect
          v-model="filters.activityPeriod"
          :options="options.activityPeriod"
        />
      </FormSection>
  
      <FormSection title="Дополнительно">
        <SectionGroup gap="medium">
          <BasicCheckbox
            v-model="filters.hasHighEducation"
            :value="1"
          >
            С высшим образованием
          </BasicCheckbox>
          <BasicCheckbox
            v-model="filters.hasExtraEducation"
            :value="1"
          >
            С дополнительным образованием
          </BasicCheckbox>
          <BasicCheckbox
            v-model="filters.hasSocialRatings"
            :value="1"
          >
            Участвует в профсообществах
          </BasicCheckbox>
        </SectionGroup>
      </FormSection>
  
      <slot name="controls" />
    </SectionGroup>
  </FiltersWatcher>
</template>

<script>
  import FiltersWatcher from 'src/components/filters/FiltersWatcher/FiltersWatcher.vue';
  import BasicCheckbox from 'src/components/form/BasicCheckbox/BasicCheckbox.vue';
  import BasicSelect from 'src/components/form/BasicSelect/BasicSelect.vue';
  import FormSection from 'src/components/form/FormSection/FormSection.vue';
  import InputGroup from 'src/components/form/InputGroup/InputGroup.vue';
  import InputRange from 'src/components/form/InputRange/InputRange.vue';
  import InputRangeGroup from 'src/components/form/InputRangeGroup/InputRangeGroup.vue';
  import CompanyPicker from 'src/components/pickers/CompanyPicker/CompanyPicker.vue';
  import EducationCenterPicker from 'src/components/pickers/EducationCenterPicker/EducationCenterPicker.vue';
  import LocationPicker from 'src/components/pickers/LocationPicker/LocationPicker.vue';
  import SkillsPicker from 'src/components/pickers/SkillsPicker/SkillsPicker.vue';
  import SpecsPicker from 'src/components/pickers/SpecsPicker/SpecsPicker.vue';
  import UniversityPicker from 'src/components/pickers/UniversityPicker/UniversityPicker.vue';
  import SectionGroup from 'src/components/sections/SectionGroup/SectionGroup.vue';

  export default {
    name: 'ResumeFilters',
    components: {
      InputGroup,
      FiltersWatcher,
      EducationCenterPicker,
      UniversityPicker,
      BasicSelect,
      CompanyPicker,
      LocationPicker,
      BasicCheckbox,
      InputRangeGroup,
      SkillsPicker,
      SpecsPicker,
      FormSection,
      SectionGroup,
      InputRange,
    },

    props: {
      filters: {
        type: Object,
        required: true,
      },
      options: {
        type: Object,
        required: true,
      },
      dynamicOptions: {
        type: Object,
        required: true,
      },
      groups: {
        type: Array,
        required: true,
      }
    },
    
    emits: ['change'],
  }
</script>